import {
  deleteObject,
  getBytes,
  getMetadata,
  getStorage,
  ref,
  uploadBytes,
} from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import { TMedia } from "../models/media.model";

export async function uploadMedia({
  file,
  onSuccess,
  onError,
}: {
  file: File;
  onSuccess?: (data: TMedia) => void;
  onError?: (data: any) => void;
}) {
  try {
    const storage = getStorage();

    const uid = uuidv4();
    const path = `uploads/${localStorage.getItem("uid")}/${uid}`;
    const storageRef = ref(storage, path);

    const data = await uploadBytes(storageRef, file);

    onSuccess?.({
      id: uid,
      name: data.metadata.name,
      mimetype: file.type,
      href: data.metadata.fullPath,
      createdAt: data.metadata.timeCreated,
      updatedAt: data.metadata.updated,
      metadata: data.metadata,
      service: "firebase",
      size: file.size,
      url: data.metadata.fullPath,
      userId: "",
    });
  } catch (exc) {
    console.error(exc);
    onError?.(exc);
  }
}

export async function getMedia({
  mediaId,
  onSuccess,
  onError,
}: {
  mediaId: string;
  onSuccess?: (data: TMedia) => void;
  onError?: (data: any) => void;
}) {
  try {
    const storage = getStorage();
    const path = `uploads/${localStorage.getItem("uid")}/${mediaId}`;
    const storageRef = ref(storage, path);

    const metadata = await getMetadata(storageRef);

    onSuccess?.({
      id: mediaId,
      name: metadata.name,
      mimetype: metadata.contentType || "",
      href: metadata.fullPath,
      createdAt: metadata.timeCreated,
      updatedAt: metadata.updated,
      metadata: metadata.customMetadata,
      service: "firebase",
      size: metadata.size,
      url: metadata.fullPath,
      userId: "",
    });
  } catch (exc) {
    console.error(exc);
    onError?.(exc);
  }
}

export async function getMediaFile({
  mediaId,
  onSuccess,
  onError,
}: {
  mediaId: string;
  onSuccess?: (data: Blob) => void;
  onError?: (data: any) => void;
}) {
  if (mediaId.startsWith("http")) {
    onSuccess?.(new Blob([]));
    return;
  }

  try {
    const storage = getStorage();
    const path = `uploads/${localStorage.getItem("uid")}/${mediaId}`;
    const storageRef = ref(storage, path);

    const arrayBuffer = await getBytes(storageRef);

    onSuccess?.(new Blob([arrayBuffer]));
  } catch (exc) {
    console.error(exc);
    onError?.(exc);
  }
}

export async function deleteMedia({
  mediaId,
  onSuccess,
  onError,
}: {
  mediaId: string;
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
}) {
  try {
    const storage = getStorage();
    const path = `uploads/${localStorage.getItem("uid")}/${mediaId}`;
    const storageRef = ref(storage, path);

    await deleteObject(storageRef);

    onSuccess?.(true);
  } catch (exc) {
    console.error(exc);
    onError?.(exc);
  }
}
